import isEmpty from 'lodash/isEmpty';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import T from 'prop-types';
import WhiteContainer from '../../../components/containers/WhiteContainer';
import List from '../../../components/list/List';
import Loading from '../../../components/loading/Loading';
import text, { formatCurrency } from '../../../text';
import { isMembershipPriceId } from '../../../utilities/membership';
import { usePaymentContext } from '../../pages/payment';
var MembershipInvoice = function(param) {
    var _param_numOrder = param.numOrder, numOrder = _param_numOrder === void 0 ? 1 : _param_numOrder, _param_isFromOrderWizard = param.isFromOrderWizard, isFromOrderWizard = _param_isFromOrderWizard === void 0 ? false : _param_isFromOrderWizard;
    var numBillableItems = usePaymentContext().numBillableItems;
    var _useSelector = useSelector(function(state) {
        return {
            membershipPriceId: state.order.membershipPriceId,
            membershipPrices: state.profileReducer.membershipPrices
        };
    }), membershipPriceId = _useSelector.membershipPriceId, membershipPrices = _useSelector.membershipPrices;
    var selectedMembership = useMemo(function() {
        var _membershipPrices_value;
        return (_membershipPrices_value = membershipPrices.value) === null || _membershipPrices_value === void 0 ? void 0 : _membershipPrices_value.find(function(membership) {
            return membership.id === membershipPriceId;
        });
    }, [
        membershipPriceId,
        membershipPrices
    ]);
    return isMembershipPriceId(membershipPriceId) && /*#__PURE__*/ React.createElement(WhiteContainer, {
        className: classNames('Invoice MembershipInvoice', {
            'mt-4': !numBillableItems && isFromOrderWizard
        })
    }, membershipPrices.isLoading ? /*#__PURE__*/ React.createElement(Loading, null) : selectedMembership && (!isFromOrderWizard ? /*#__PURE__*/ React.createElement(MembershipManagementTemplate, {
        selectedMembership: selectedMembership
    }) : /*#__PURE__*/ React.createElement(OrderWizardTemplate, {
        selectedMembership: selectedMembership,
        numOrder: numOrder
    })));
};
export default MembershipInvoice;
// BREAKDOWN TEMPLATES
var MembershipManagementTemplate = function(param) {
    var selectedMembership = param.selectedMembership;
    var cardHeading = usePaymentContext().cardHeading;
    if (isEmpty(selectedMembership)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h6", {
        className: "green-1"
    }, "1.", ' ', text('_invoiceType', {
        prefix: cardHeading,
        type: text('membership')
    })), /*#__PURE__*/ React.createElement(List, null, /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement(List.Item, {
        description: selectedMembership === null || selectedMembership === void 0 ? void 0 : selectedMembership.name,
        value: formatCurrency(selectedMembership.grand_total, selectedMembership.currency.name, selectedMembership.currency.scale_factor, {}, true)
    }))), /*#__PURE__*/ React.createElement(List, null, /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement(List.Item, {
        description: text('subtotal'),
        value: formatCurrency(selectedMembership.subtotal, selectedMembership.currency.name, selectedMembership.currency.scale_factor, {}, true)
    }), selectedMembership.taxes.map(function(tax, i) {
        return /*#__PURE__*/ React.createElement(List.Item, {
            key: i,
            description: tax.display_name,
            value: formatCurrency(tax.price.extra, selectedMembership.currency.name, selectedMembership.currency.scale_factor, {}, true)
        });
    }), /*#__PURE__*/ React.createElement(List.Item, {
        isHighlighted: true,
        description: text('total'),
        value: formatCurrency(selectedMembership.grand_total, selectedMembership.currency.name, selectedMembership.currency.scale_factor, {}, true)
    }))));
};
MembershipManagementTemplate.propTypes = {
    selectedMembership: T.object
};
var OrderWizardTemplate = function(param) {
    var selectedMembership = param.selectedMembership, numOrder = param.numOrder;
    var cardHeading = usePaymentContext().cardHeading;
    if (isEmpty(selectedMembership)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h6", {
        className: "green-1 font-weight--600 mb-0"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "mr-1"
    }, numOrder, "."), ' ', /*#__PURE__*/ React.createElement("span", null, text('_invoiceType', {
        prefix: cardHeading,
        type: text('membership')
    }))), /*#__PURE__*/ React.createElement("div", {
        style: {
            paddingLeft: '20px',
            paddingRight: '16px'
        }
    }, /*#__PURE__*/ React.createElement(List, null, /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement(List.Item, {
        description: selectedMembership === null || selectedMembership === void 0 ? void 0 : selectedMembership.name,
        value: formatCurrency(selectedMembership === null || selectedMembership === void 0 ? void 0 : selectedMembership.subtotal, selectedMembership === null || selectedMembership === void 0 ? void 0 : selectedMembership.currency.name, selectedMembership === null || selectedMembership === void 0 ? void 0 : selectedMembership.currency.scale_factor, {}, true)
    })))));
};
OrderWizardTemplate.propTypes = {
    selectedMembership: T.object,
    numOrder: T.number
};
